<template>
  <div class="locationList">
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <Grid
        :ref="kgm_ref"
        :style="{height: 'auto'}"
        :data-items="kgm_computedGridItems(locations)"
        :columns="kgm_responsiveColumns()"
        :filterable="false"
        :filter="kgm_filter"
        :pageable="kgm_pagable"
        :page-size="kgm_take"
        :skip="kgm_skip"
        :take="kgm_take"
        :total="kgm_allGridItems(locations)"
        :sortable="{
          allowUnsort: true,
          mode: kgm_sortMode
        }"
        :sort="kgm_sort"
        selected-field="selected"
        @rowclick="kgm_gridOnRowClick"
        @filterchange="kgm_gridFilterChange"
        @pagechange="kgm_gridPageChange"
        @sortchange="kgm_gridSortChange"
      >
        <template
          slot="booleanTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <input
              :checked="kgm_getNestedValue(props.field, props.dataItem)"
              type="checkbox"
              disabled
              readonly
            >
          </td>
        </template>
        <template
          slot="optionsTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <div class="btn-group">
              <button
                class="btn btn-primary btn-sm"
                @click="showSidebarEdit(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="edit"
                />
                <span>{{ $t('edit') }}</span>
              </button>
              <button
                slot="button"
                class="btn btn-danger btn-sm"
                @click="openConfirmModal(props.dataItem)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="trash"
                />
              </button>
            </div>
          </td>
        </template>
      </Grid>
      <Sidebar
        v-if="showSidebar"
        :show-sidebar="showSidebar"
        @close="close"
      >
        <LocationAdd
          v-if="addingElement"
          :resort-id="resortId"
          @reload="reloadLocations"
        />
        <LocationEdit
          v-else
          :resort-id="resortId"
          :location="location"
          @reload="reloadLocations"
        />
      </Sidebar>
    </template>
    <SweetModal
      ref="confirmDelete"
      :title="$t('introOutroListComp.deleteElement')"
      icon="warning"
    >
      <p v-if="locationId">
        {{ $t('sureToDelete', {'0' : locationId }) }}
      </p>
      <button
        slot="button"
        class="btn btn-secondary float-left mb-3"
        @click="$refs.confirmDelete.close()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="times"
        />{{ $t('cancel') }}
      </button>
      <button
        slot="button"
        class="btn btn-danger float-right mb-3"
        @click="removeLocation()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="trash"
        />{{ $t('delete') }}
      </button>
      <div class="clearfix" />
    </SweetModal>
  </div>
</template>

<script>
import { kendoGridMixin } from '@/mixins/kendoGridMixin.js';
import LocationAdd from '@/components/Resort/LocationAdd';
import LocationEdit from '@/components/Resort/LocationEdit';
import Sidebar from '@/components/Base/Sidebar.vue';
import { SweetModal } from 'sweet-modal-vue';

export default {
  name: "LocationList",
  components: {
    Sidebar,
    LocationAdd,
    LocationEdit,
    SweetModal
  },
  mixins: [
    kendoGridMixin
  ],
  props: {
    resortId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      locations: null,
      location: null,
      showSidebar: false,
      addingElement: false,
      locationId: null,
      kgm_columns: [
        {
          field: 'id',
          filterable: false,
          title: 'Id',
        },
        {
          field: 'location.altitude',
          filterable: false,
          filter: 'text',
          title: 'Altitude',
          hideOn: ['xsDown']
        },
        {
          field: 'location.latitude',
          filterable: false,
          filter: 'text',
          title: 'Latitude',
          hideOn: ['xsDown']
        },
        {
          field: 'location.longitude',
          filterable: false,
          filter: 'text',
          title: 'Longitude',
          hideOn: ['xsDown']
        },
        {
          filterable: false,
          title: 'Options',
          cell: 'optionsTemplate',
        }
      ]
    }
  },
  watch: {
    resortId () {
      this.getData();
    }
  },
  created () {
    this.getData();
  },
  methods: {
    //sidebar
    openConfirmModal (data) {
      this.locationId = data.id;
      this.$refs.confirmDelete.open();
    },
    show () {
      this.showSidebar = true;
    },
    close () {
      this.showSidebar = false;
    },
    showSidebarAdd () {
      this.addingElement = true;
      this.show();
    },
    showSidebarEdit (emitValues) {
      this.setCurrentLocation(emitValues);
      this.addingElement = false;
      this.show();
    },
    setCurrentLocation (location) {
      this.location = JSON.parse(JSON.stringify(location)); 
    },
    reloadLocations () {
      this.showSidebar = false;
      this.$emit("reloadAuditLogs");
      this.getData();
    },
    //#region API-calls
    getData () {
      this.loading = true;
      this.axios.get(`/Resort/GetResortLocations?resortId=${ this.resortId }&includeSharedResorts=true`)
      .then(response => {
        this.locations = response.data;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    removeLocation () {
      this.loading = true;
      this.axios.delete(`/Resort/RemoveLocation?id=${ this.locationId }`)
      .then(() => {
        this.$snotify.success("removed location");
        this.locationId = null;
        this.$refs.confirmDelete.close();
        this.getData();
      })
      .finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style>
.locationList .k-grid table tr:hover td {
  background :rgb(219, 219, 219) !important;
  cursor: pointer !important;
}
</style>
